{
  "toast": {
    "unmarkedComplete": "Clase desmarcada como completada",
    "markedComplete": "¡Clase marcada como completada!",
    "statusError": "Error al actualizar el estado de la clase",
    "favoriteRemoved": "Eliminado de favoritos",
    "favoriteAdded": "¡Añadido a favoritos!",
    "favoriteError": "Error al actualizar el favorito",
    "ratingSent": "¡Valoración enviada!",
    "ratingError": "Error al enviar la valoración",
    "notesError": "No se pudieron guardar tus notas. Inténtalo de nuevo.",
    "pdfLoaded": "¡PDF {{title}} cargado!",
    "assignmentSubmitted": "¡Actividad enviada correctamente!"
  },
  "notFound": {
    "title": "Clase no encontrada",
    "description": "Esta clase no existe o no tienes acceso.",
    "back": "Volver"
  },
  "progress": {
    "thisLesson": "Esta clase",
    "course": "Curso"
  },
  "sidebar": {
    "moduleLessons": "Clases del módulo",
    "close": "Cerrar",
    "completedShort": "{{completed}}/{{total}} clases completadas",
    "completedLong": "{{completed}} de {{total}} clases completadas",
    "upNext": "Siguiente"
  },
  "content": {
    "assignmentInstructions": "Instrucciones de la actividad",
    "supportMaterials": "Materiales de apoyo",
    "supportMaterialsDescription": "Descarga los archivos necesarios para completar esta actividad",
    "submitSolution": "Envía tu solución",
    "submitSolutionDescription": "Sube los archivos de tu actividad terminada",
    "aboutFiles": "Sobre los archivos",
    "downloadFiles": "Archivos para descargar",
    "downloadFilesDescription": "Descarga los materiales y recursos de esta clase"
  },
  "live": {
    "title": "Clase en vivo",
    "scheduledFor": "Programada para el {{date}}",
    "description": "Esta es una clase en vivo. ¡Atento a los horarios!",
    "join": "Entrar en la clase"
  },
  "info": {
    "minutes": "{{minutes}} min",
    "lessonsProgress": "{{completed}}/{{total}} clases ({{percent}}%)"
  },
  "actions": {
    "saving": "Guardando...",
    "completed": "Completada",
    "complete": "Completar",
    "favorited": "En favoritos",
    "favorite": "Añadir a favoritos",
    "rated": "Valorada",
    "rate": "Valorar"
  },
  "rating": {
    "question": "¿Cómo valoras esta clase?",
    "cancel": "Cancelar",
    "submit": "Enviar"
  },
  "attachments": {
    "title": "Material de apoyo"
  },
  "navigation": {
    "previous": "Anterior",
    "next": "Siguiente"
  },
  "notes": {
    "title": "Notas",
    "saving": "Guardando...",
    "saved": "Guardado",
    "autosave": "Se guarda automáticamente",
    "placeholder": "Escribe tus notas aquí..."
  },
  "locked": {
    "title": "Clase bloqueada",
    "description": "Todavía no tienes acceso al curso de esta clase.",
    "browse": "Ver cursos"
  },
  "player": {
    "play": "Reproducir",
    "pause": "Pausar",
    "mute": "Silenciar",
    "unmute": "Activar sonido",
    "enterFullscreen": "Pantalla completa",
    "exitFullscreen": "Salir de pantalla completa",
    "settings": "Ajustes",
    "speed": "Velocidad",
    "normal": "Normal",
    "quality": "Calidad",
    "pip": "Imagen en imagen",
    "rewind": "Retroceder {seektime}s",
    "fastForward": "Avanzar {seektime}s"
  },
  "stream": {
    "loading": "Cargando video",
    "loadError": "No se pudo cargar el video.",
    "retry": "Intentar de nuevo",
    "playerTitle": "Reproductor de la clase",
    "resumeHere": "Seguir viendo aquí",
    "completesByWatching": "Se completa al verla",
    "watchToComplete": "Mira al menos el 90 % del video para completar la clase."
  }
}
